import z from "zod";
import z4, {$ZodShape, ParsePayload} from 'zod/v4/core'


// type LowercaseKeys<T> = {
//   [K in keyof T as Lowercase<string & K>]: K
// };

export function createCaseInsensitiveLookup<Shape extends z4.$ZodShape = z4.$ZodLooseShape>(shape: Shape): Record<string, string|undefined> {
  const result: Record<string, string|undefined> = {};
  for (const key of Object.keys(shape)) {
    result[key.toLowerCase()] = key
  }
  return result;
}


export function zBooleanWrapper(def: boolean = false) {
  return z.union([z.boolean(), z.stringbool()]).default(def)
}


export function removeNullValues(arg: unknown, ctx: ParsePayload): unknown {
  if (arg === null || arg === undefined) {
    return undefined;
  }

  if (Array.isArray(arg)) {
    return arg.map(item => removeNullValues(item, ctx)).filter(item => item !== undefined);
  }

  if (typeof arg === 'object') {
    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(arg)) {
      const cleaned = removeNullValues(value, ctx);
      if (cleaned !== undefined) {
        result[key] = cleaned;
      }
    }
    return result;
  }

  return arg;
}

export function parsePartial<T>(input: any, rawType: z.ZodObject & z4.$ZodType<T>, preprocessor: (input: unknown, ctx: ParsePayload) => unknown, caseInsensitiveLookup: Record<string, string|undefined>): Partial<T> {
  const inputKeys = Object.keys(input)
  const objectToParse: any = {}
  for(let key of inputKeys) {
    const convertedKey = key.toLowerCase()
    const lookUpKey = caseInsensitiveLookup[convertedKey]
    if(lookUpKey) {
      objectToParse[lookUpKey] = input[key]
    }
  }

  const upgradedObjectToParse = z.transform(preprocessor).pipe(z.unknown()).parse(objectToParse)
  const upgradedKeys = Object.keys(upgradedObjectToParse as object)
  let upgradedKeysToParse: Record<string, true> = {}
  for(let key of upgradedKeys) {
    upgradedKeysToParse[key] = true
  }

  const partialConfiguration = rawType.pick(upgradedKeysToParse)
  return partialConfiguration.parse(upgradedObjectToParse) as Partial<T>
}


export function createPartialParser<T>(rawType: z.ZodObject & z4.$ZodType<T>, preprocessor: (input: unknown, ctx: ParsePayload) => unknown, additionalShape: $ZodShape = {}): (input: any) => Partial<T> {
  const caseInsensitiveLookup = createCaseInsensitiveLookup({
    ...rawType.shape,
    // need to add all previous defined and deprecated fields here
    ...additionalShape
  })

  return (input: any) => parsePartial(input, rawType, preprocessor, caseInsensitiveLookup)
}
